import React, { useEffect, useState } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBug,
  faBugs,
  faCapsules,
  faCheck,
  faCopy,
  faLeaf,
  faPen,
  faPills,
  faPlus,
  faTrash,
  faWheatAwn,
} from '@fortawesome/free-solid-svg-icons'
import { AxiosResponse } from 'axios'
import { orderBy } from 'lodash'
import { InsumosItens } from '../../../../../../../../services/recomendacao/insumos'
import { ItensPerUserLogged } from '../../../../../../../../services/login/permissaoUsuarioLoado'
import { Collapse, Empty } from 'antd'
import { getMoniEspecie, MoniEspecieItens, TypeMoniEspecie } from '../../../../../../../../services/monitoramento/especie'
import { tiposGerais, tiposSistema } from '../../../../../../../../services/Afins'
import ButtonCustom from '../../../../../../../../Components/ButtonCustom'
import { Popconfirm } from 'antd/lib'
import { DeleteButton } from '../../../../../../../../Components/CustomUi/deleteButton'
import { Box } from '../../../../../../../../Components/CustomUi/box'
import Input from '../../../../../../../../Components/CustomUi/input'
import { HeaderTable } from '../../../../../../../../Components/CustomUi/table/headerTable'
import { BodyTable } from '../../../../../../../../Components/CustomUi/table/bodyTable'
import { Render } from '../../../../../../../../Components/CustomUi/render'
import { RowTable } from '../../../../../../../../Components/CustomUi/table/rowTable'
import { RowItem } from '../../../../../../../../Components/CustomUi/table/rowItem'
import Carregando from '../../../../../../../../Components/CustomUi/loading'
import { propsPopconfirm } from '../../../../../../../../Components/Default'
import { Select } from '../../../../../../../../Components/CustomUi/Select'

interface PropsFormAplicacao {
  cultura: string
  setCultura: React.Dispatch<React.SetStateAction<string>>
  culturaId: number
  setCulturaId: React.Dispatch<React.SetStateAction<number>>
  faseDeCultura: string
  setFaseDeCultura: React.Dispatch<React.SetStateAction<string>>
  faseDeCulturaId: number
  setFaseDeCulturaId: React.Dispatch<React.SetStateAction<number>>
  especie: string
  setEspecie: React.Dispatch<React.SetStateAction<string>>
  especieId: number
  setEspecieId: React.Dispatch<React.SetStateAction<number>>
  variacaoEspecie: string
  setVariacaoEspecie: React.Dispatch<React.SetStateAction<string>>
  variacaoEspecieId: number
  setVariacaoEspecieId: React.Dispatch<React.SetStateAction<number>>
  doseBula: string
  setDoseBula: React.Dispatch<React.SetStateAction<string>>
  doseUsual: string
  setDoseUsual: React.Dispatch<React.SetStateAction<string>>
  doseBulaUpdate: string
  setDoseBulaUpdate: React.Dispatch<React.SetStateAction<string>>
  doseUsualUpdate: string
  setDoseUsualUpdate: React.Dispatch<React.SetStateAction<string>>
  alvoSelect: number
  setAlvoSelect: React.Dispatch<React.SetStateAction<string | number>>
  confirmar_exclusao: boolean
  setConfirmar_exclusao: React.Dispatch<React.SetStateAction<boolean>>
  id_item_atual: string | number
  setId_item_atual: React.Dispatch<React.SetStateAction<string | number>>
  nome_item_atual: string
  setNome_item_atual: React.Dispatch<React.SetStateAction<string>>
  fake_loading: boolean
  setFake_loading: React.Dispatch<React.SetStateAction<boolean>>
  dataUnidadeMedida: any[]
  loadingAlvos: boolean
  unidadeMedidaId: number
  aplicacoes: InsumosItens['aplicacoes']
  handleInsertCultura: Function
  adicionarAlvo: Function
  updateAlvo: Function
  removerAlvo: Function
  copiarAlvo: Function
  handleClickCloneAplica: Function
  handleRemoveCultura: Function
  permissions: ItensPerUserLogged
  dataEspecie: MoniEspecieItens[]
}

export const FormAplicacao: React.FC<PropsFormAplicacao> = ({
  cultura,
  setCultura,
  culturaId,
  setCulturaId,
  faseDeCultura,
  setFaseDeCultura,
  faseDeCulturaId,
  setFaseDeCulturaId,
  especie,
  setEspecie,
  especieId,
  setEspecieId,
  variacaoEspecie,
  setVariacaoEspecie,
  variacaoEspecieId,
  setVariacaoEspecieId,
  doseBula,
  setDoseBula,
  doseUsual,
  setDoseUsual,
  doseBulaUpdate,
  setDoseBulaUpdate,
  doseUsualUpdate,
  setDoseUsualUpdate,
  alvoSelect,
  setAlvoSelect,
  confirmar_exclusao,
  setConfirmar_exclusao,
  id_item_atual,
  setId_item_atual,
  nome_item_atual,
  setNome_item_atual,
  fake_loading,
  setFake_loading,
  aplicacoes,
  loadingAlvos,
  handleInsertCultura,
  adicionarAlvo,
  updateAlvo,
  removerAlvo,
  copiarAlvo,
  unidadeMedidaId,
  dataUnidadeMedida,
  handleClickCloneAplica,
  handleRemoveCultura,
  permissions,
  dataEspecie
}) => {
  const { Panel } = Collapse
  const [dataCultura, setDataCultura] = useState([])
  const [dataFaseCultura, setDataFaseCultura] = useState([])
  const [dataEspecieVariacao, setDataEspecieVariacao] = useState([])
  const [openCultura, setOpenCultura] = useState(false)
  const [openFaseCultura, setOpenFaseCultura] = useState(false)
  const [openEspecie, setOpenEspecie] = useState(false)
  const [openEspecieVariacao, setOpenEspecieVariacao] = useState(false)

  const listCultura = async () => {
    const resp = await tiposGerais()

    setDataCultura(resp)
  }

  const listFaseCultura = async () => {
    const resp = await tiposSistema(13)

    setDataFaseCultura(resp)
  }



  function escolherEspecieVariacao(cod) {
    setEspecieId(cod)
    const variacoes = dataEspecie.filter((item) => item.cod === cod)
    setDataEspecieVariacao(variacoes[0]?.variacao)
  }

  function nomeEspecie(cod, cod_variedade) {

    if (dataEspecie.length > 0) {
      const especie = dataEspecie.filter((item) => item.cod === cod)

      let variacao = ''
      const variacaoEspecie = especie[0]?.variacao.filter(item => item?.cod === cod_variedade)

      if (especie[0]?.variacao[0]?.nome === undefined) {
        variacao = `${especie[0]?.nome}`
      } else {
        variacao = `${especie[0]?.nome} | ${variacaoEspecie[0]?.nome}`
      }
      return variacao
    }
  }

  const handleChangeMask = (data, input) => {
    let area = data
    area = area.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    area = (area / 100).toFixed(2).replace('.', ',')
    if (input === 'bula') {
      setDoseBula(area)
    }

    if (input === 'usual') {
      setDoseUsual(area)
    }
  }

  const handleChangeMaskUpdate = (data, input) => {
    let area = data
    area = area.replace(/([\u0300-\u036f]|[^0-9a-zA-Z\s])/g, '')
    area = (area / 100).toFixed(2).replace('.', ',')
    if (input === 'bula') {
      setDoseBulaUpdate(area)
    }

    if (input === 'usual') {
      setDoseUsualUpdate(area)
    }
  }

  function dadosBula(dose_bula, dose_usual) {
    setDoseBulaUpdate(dose_bula)
    setDoseUsualUpdate(dose_usual)
  }

  useEffect(() => {
    if (especie === '') {
      setDataEspecieVariacao([])
    }
  }, [especie])

  useEffect(() => {
    listCultura()
    listFaseCultura()
  }, [])
  console.log("aplicacoes? ", aplicacoes);
  return (
    <div style={{ display: 'flex', gap: 10, flexDirection: 'column' }}>
      <div className='campo__dois__inputs'>
        <Select
          label='Cultura'
          placeholder='Selecione a cultura'
          icon={faWheatAwn}
          value={cultura}
          onChange={setCultura}
          onChangeID={setCulturaId}
          open={openCultura}
          trigger={setOpenCultura}
          items={dataCultura}
          descricaoItem={'nome'}
          idItem={'cod'}
          disabled={permissions?.acesso === 1}
        />
        <Select
          label='Fase da cultura'
          placeholder='Selecione a fase da cultura'
          icon={faLeaf}
          value={faseDeCultura}
          onChange={setFaseDeCultura}
          onChangeID={setFaseDeCulturaId}
          open={openFaseCultura}
          trigger={setOpenFaseCultura}
          items={dataFaseCultura}
          descricaoItem={'nome'}
          idItem={'cod'}
          disabled={permissions?.acesso === 1}
        />

        <div style={{ height: '55px', display: 'flex', alignItems: 'flex-end' }}>
          <ButtonCustom
            isCircle
            onClick={handleInsertCultura}
            icon={<FontAwesomeIcon icon={faPlus} />}
            disabled={permissions?.acesso === 1}
          />
        </div>
      </div>
      <Collapse accordion destroyInactivePanel>
        {aplicacoes?.map((item, i) => (
          <Panel
            header={
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <p style={{ padding: '0px', margin: '0px' }}>{item?.cultura_nome}</p>

                <strong>({item?.fase_cultura_nome})</strong>
              </div>
            }
            key={item.cod}
            extra={
              <div style={{ display: 'flex', gap: '10px' }}>
                <Popconfirm
                  {...propsPopconfirm}
                  title='Deseja clonar essa aplicação?'
                  onConfirm={() => handleClickCloneAplica(item?.cod, faseDeCultura)}
                >
                  <ButtonCustom
                    onClick={undefined}
                    type='secondary'
                    icon={<FontAwesomeIcon icon={faCopy} />}
                    disabled={permissions?.acesso === 1}
                  />{' '}
                </Popconfirm>

                <DeleteButton
                  open={confirmar_exclusao && id_item_atual === item?.cod}
                  trigger={setConfirmar_exclusao}
                  onTrigger={() => {
                    setId_item_atual(item?.cod)
                    setNome_item_atual(item?.cultura_nome)
                  }}
                  loading={fake_loading}
                  message={`o item ${item?.cultura_nome} será excluido!`}
                  deleteds={[`${item?.cultura_nome}`]}
                  onDelete={() => handleRemoveCultura(item?.cod)}
                  disabled={fake_loading || permissions?.acesso === 1}
                  typeButtonTrigger='tertiary'
                />
              </div>
            }
          >
            <Box gap={10}>
              <div className='campo__dois__inputs'>
                <Select
                  label='Espécie'
                  placeholder='Selecione a espécie'
                  icon={faBug}
                  value={especie}
                  onChange={setEspecie}
                  onChangeID={escolherEspecieVariacao}
                  open={openEspecie}
                  trigger={setOpenEspecie}
                  items={dataEspecie}
                  descricaoItem={'nome'}
                  idItem={'cod'}
                  disabled={permissions.acesso === 1}
                />
                <Select
                  label='Variação da espécie'
                  placeholder='Selecione a espécie'
                  icon={faBugs}
                  value={variacaoEspecie}
                  onChange={setVariacaoEspecie}
                  onChangeID={setVariacaoEspecieId}
                  open={openEspecieVariacao}
                  trigger={setOpenEspecieVariacao}
                  items={dataEspecieVariacao}
                  descricaoItem={'nome'}
                  idItem={'cod'}
                  disabled={dataEspecieVariacao?.length <= 0 || permissions?.acesso === 1}
                />
              </div>
              <div className='campo__dois__inputs'>
                <Input
                  label='Dose de bula'
                  icon={faCapsules}
                  placeholder='Digite a dose de bula'
                  value={doseBula}
                  onChange={(e) => handleChangeMask(e, 'bula')}
                  desabilitado={permissions?.acesso === 1}
                />
                <Input
                  label='Dose usual'
                  icon={faCapsules}
                  placeholder='Digite a dose usual'
                  value={doseUsual}
                  onChange={(e) => handleChangeMask(e, 'usual')}
                  desabilitado={permissions?.acesso === 1}
                />
              </div>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <ButtonCustom
                  icon={<FontAwesomeIcon icon={faPlus} />}
                  onClick={() => adicionarAlvo(item?.cod, i)}
                  disabled={permissions?.acesso === 1}
                >
                  Inserir
                </ButtonCustom>
              </div>
            </Box>
            <div style={{ marginTop: '10px' }}>
              <HeaderTable
                itens={[
                  { valor: 'Espécie', width: 'calc(100% - 535.5px)' },
                  { valor: 'Dose de bula', width: '120px' },
                  { valor: 'Dose usual', width: '120px' },
                  { valor: 'Unidade', width: '120px' },
                  { valor: 'Ações', width: '170px' },
                ]}
              />

              <BodyTable
                style={{
                  height: 'calc(100% - 100px )',
                  position: 'relative',
                  overflowX: 'hidden',
                  overflowY: 'scroll',
                  marginTop: -10,
                }}
              >
                <Render condition={loadingAlvos === false}>
                  {item?.alvos?.map((rec, index) => {

                    return (
                      <RowTable style={{ height: '80px' }} key={rec.cod} onDoubleClick={() => { }}>
                        <RowItem fontSize={12} width={'calc(100% - 530px)'}>
                          {nomeEspecie(rec.cod_especie, rec.cod_variacao_especie)}
                        </RowItem>
                        <RowItem fontSize={12} width={'120px'}>
                          {alvoSelect !== rec.cod ? (
                            rec.dose_bula
                          ) : (
                            <Input
                              placeholder={''}
                              allowClear={false}
                              value={doseBulaUpdate}
                              onChange={(e) => handleChangeMaskUpdate(e, 'bula')}
                            />
                          )}
                        </RowItem>
                        <RowItem fontSize={12} width={'120px'}>
                          {alvoSelect !== rec.cod ? (
                            rec.dose_usual
                          ) : (
                            <Input
                              placeholder={''}
                              allowClear={false}
                              value={doseUsualUpdate}
                              onChange={(e) => handleChangeMaskUpdate(e, 'usual')}
                            />
                          )}
                        </RowItem>

                        <RowItem fontSize={12} width={'120px'}>
                          {dataUnidadeMedida.find((item) => item.cod === unidadeMedidaId)?.nome}
                        </RowItem>

                        <RowItem width={'170px'} gap={10}>
                          <DeleteButton
                            open={confirmar_exclusao && id_item_atual === rec.cod}
                            trigger={setConfirmar_exclusao}
                            onTrigger={() => {
                              setId_item_atual(rec.cod)
                              setNome_item_atual(nomeEspecie(rec.cod_especie, rec.cod_variacao_especie))
                            }}
                            loading={fake_loading}
                            message={`o item ${nomeEspecie(rec.cod_especie, rec.cod_variacao_especie)} será excluido!`}
                            deleteds={[`${nomeEspecie(rec.cod_especie, rec.cod_variacao_especie)}`]}
                            onDelete={() => removerAlvo(rec.cod, item.cod, index)}
                            disabled={fake_loading || permissions?.acesso === 1}
                            typeButtonTrigger='tertiary'
                          />
                          <ButtonCustom
                            onClick={() => copiarAlvo(rec)}
                            icon={<FontAwesomeIcon icon={faCopy} />}
                            type='secondary'
                            disabled={permissions?.acesso === 1}
                          />
                          <ButtonCustom
                            onClick={() => {
                              if (alvoSelect > 0 || typeof alvoSelect === 'string') {
                                updateAlvo(rec?.cod_especie, rec?.cod_variacao_especie, index, item?.cod, i, rec?.cod, rec)
                                setAlvoSelect(0)
                              } else {
                                setAlvoSelect(rec.cod)
                                dadosBula(rec.dose_bula, rec.dose_usual)
                              }
                            }}
                            icon={
                              <FontAwesomeIcon icon={alvoSelect === rec.cod ? faCheck : faPen} />
                            }
                            disabled={rec.cod === null || permissions?.acesso === 1}
                          />
                        </RowItem>
                      </RowTable>
                    )
                  })}
                </Render>

                <Render condition={!item?.hasOwnProperty('alvos')}>
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={<> Nenhum alvo cadastrado!</>}
                  />
                </Render>

                <Render condition={loadingAlvos}>
                  <Carregando
                    animation
                    legenda='Carregando alvos...'
                    justifyContent='center'
                    height={'300px'}
                    size='default'
                  />
                </Render>
              </BodyTable>
            </div>
          </Panel>
        ))}
      </Collapse>
    </div>
  )
}